export enum StoreIdsEnum {
  MANAGE_INSTITUTE_TEST = "manageInstituteTest",
  MANAGE_ASSIGNMENT = "manageAssignment",
  MANAGE_LIVE_CLASS = "manageLiveClass",
  MANAGE_AFFILIATION = "manageAffiliation",
  OFFLINE_TEST_SUBJECT_WISE_REPORT = "offlineTestSubjectWiseReport",
  MANAGE_QR_CODES = "manageQrCodes",
  TUTORING_TUTOR_DASHBOARD = "tutoringTutorDashboard",
  TUTORING_STUDENT_DASHBOARD = "tutoringStudentDashboard",
  TUTORING_ADMIN_DEMO_SESSIONS = "tutoringAdminDemoSessions",
  TUTORING_ADMIN_PAID_SESSIONS = "tutoringAdminPaidSessions",
}
